import { useTranslations } from 'next-intl';

/**
 * Returns a VAT label like "(brutto)" or "(netto)",
 * based on whether the customer is private or business.
 */
export default function useVatLabel(isPrivateCustomer: boolean) {
  const t = useTranslations('priceBreakdown.germany.label');
  return isPrivateCustomer ? t('bruttoPrice') : t('nettoPrice');
}
